import React from 'react';
import SelectSearch from './SelectSearch';
import ActivityLoader from './ActivityLoader';

const TextInput = ({
  label,
  labelStyle,
  type = 'text',
  wrap,
  placeholder,
  value,
  onChange,
  readonly = false,
  required = false,
  name,
  autoFocus,
  options = [],
  leftIcon,
  leftComponent,
  loading,
  onType,
  style,
  accept
}) => {
  const inputType = type;

  return (
    <div className='form-group row' style={style}>
      {label && (
        <label
          style={labelStyle}
          className={`col-form-label ${wrap ? 'col-sm-12' : 'col-sm-3 '}`}
        >
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <div className={`${wrap ? 'col-sm-12' : 'col-sm-9'}`}>
        <div className='input-group mb-0'>
          {leftIcon && (
            <div className='input-group-prepend'>
              <span className='input-group-text'>
                {!loading ? (
                  <>
                    {!leftComponent && <i className={leftIcon}></i>}
                    {leftComponent}
                  </>
                ) : (
                  <ActivityLoader inline={true} size={16.8} />
                )}
              </span>
            </div>
          )}

          {inputType !== 'textarea' && inputType !== 'select' && (
            <input
              type={inputType}
              className='form-control'
              placeholder={placeholder || label}
              onChange={onChange}
              value={value}
              autoFocus={autoFocus}
              readOnly={readonly}
              required={required}
              name={name}
              accept={accept}
            />
          )}

          {inputType === 'textarea' && (
            <textarea
              className='form-control'
              placeholder={placeholder || label}
              onChange={onChange}
              value={value}
              readOnly={readonly}
              required={required}
            />
          )}

          {inputType === 'select' && (
            <SelectSearch
              placeholder={placeholder || label}
              className='form-control'
              options={options}
              onChange={onChange}
              onType={onType}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TextInput;
